import { render } from "./CardNoticias.vue?vue&type=template&id=6c8ec20a"
import script from "./CardNoticias.vue?vue&type=script&lang=js"
export * from "./CardNoticias.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__